import { render, staticRenderFns } from "./brandbar.vue?vue&type=template&id=1bd5769b&scoped=true&"
import script from "./brandbar.vue?vue&type=script&lang=js&"
export * from "./brandbar.vue?vue&type=script&lang=js&"
import style0 from "./brandbar.vue?vue&type=style&index=0&id=1bd5769b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd5769b",
  null
  
)

export default component.exports